module.exports = __webpack_public_path__ + "img/message-icon.d0e72c47.png";